// src/utils/isMobileDevice.js
//
// Returns true only for an ACTUAL mobile device (phone / touch tablet), NOT for
// a narrow desktop window. This is deliberately viewport-WIDTH independent so a
// desktop browser in split-screen / a small window is never treated as mobile.
//
// Signal priority (most → least authoritative):
//   1. navigator.userAgentData.mobile  — Chromium Client Hints (boolean truth)
//   2. User-Agent string match         — Android / iPhone / iPad(iOS13+) / etc.
//   3. (hover: none) and (pointer: coarse) — touch-primary device with no mouse
export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;

  // 1. Client Hints — authoritative on Chromium-based browsers.
  if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
    return navigator.userAgentData.mobile;
  }

  const ua = navigator.userAgent || '';

  // 2. Classic mobile/tablet user agents.
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)) {
    return true;
  }
  // iPadOS 13+ reports a Mac UA — distinguish via touch support.
  if (/iPad/i.test(ua) || (/Macintosh/i.test(ua) && typeof document !== 'undefined' && 'ontouchend' in document)) {
    return true;
  }

  // 3. Capability fallback: touch-primary device without a fine pointer/hover.
  //    A desktop (even in a tiny split-screen window) keeps hover:hover /
  //    pointer:fine, so it is NOT matched here.
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  return false;
}
